import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { computed } from 'vue';

    /* Props the parent form will pass */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'AQCheckBox',
  props: {
    modelValue: { type: [Boolean, Array] },
    fieldProps: {},
    label: {},
    color: {},
    border: { type: Boolean },
    hideDetails: { type: Boolean },
    value: {},
    disabled: { type: Boolean },
    direction: {},
    density: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;
    const innerValue = computed({
        get: () => props.modelValue,
        set: (val: boolean | unknown[]) => emit('update:modelValue', val),
    });

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(_component_v_checkbox, _mergeProps({
    modelValue: innerValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event))
  }, props.fieldProps, {
    label: props.label,
    value: props.value,
    disabled: props.disabled,
    style: { border: props.border ? '1px solid black' : 'none' },
    class: props.border ? 'checkboxBorder' : '',
    color: props.color,
    "hide-details": props.hideDetails || props.border,
    direction: props.direction,
    density: props.density
  }), {
    label: _withCtx(() => [
      (_ctx.$slots.default)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.label), 1))
    ]),
    _: 3
  }, 16, ["modelValue", "label", "value", "disabled", "style", "class", "color", "hide-details", "direction", "density"]))
}
}

})